"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderBadge = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * @internal
 */
exports.HeaderBadge = function (_a) {
    var children = _a.children, color = _a.color, backgroundColor = _a.backgroundColor;
    return (react_1.default.createElement("div", { className: "gd-header-badge", style: { color: color, backgroundColor: backgroundColor } }, children));
};
//# sourceMappingURL=HeaderBadge.js.map